import type { IntegrationResponse } from "@somewear/api";
import { GetOrganizationIntegrationAccountsResponse } from "@somewear/api";
import type { IIntegrationIdentity } from "@somewear/model";

export function getIntegrationType(integration: IntegrationResponse.AsObject) {
	if (Boolean(integration.federatedTakServer)) {
		return GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType
			.FEDERATED_TAK;
	}

	if (Boolean(integration.takServer || integration.sitx)) {
		return GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType.TAK;
	}

	if (Boolean(integration.webhook)) {
		return GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType
			.WEBHOOK;
	}

	return GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType.NONE;
}

export function getIntegrationDisplayType(integration: IIntegrationIdentity) {
	if (integration.integrationData?.sitx) {
		return "Sit(x) Bridge Adapter";
	}

	if (
		integration.integrationType ===
		GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType.FEDERATED_TAK
	) {
		return "TAK Server (Two-Way)";
	}

	if (
		integration.integrationType ===
		GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType.TAK
	) {
		return "TAK Server (One-Way)";
	}

	if (
		integration.integrationType ===
		GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.IntegrationType.WEBHOOK
	) {
		return "Webhook";
	}

	return null;
}

export function formatIntegration(
	integration: GetOrganizationIntegrationAccountsResponse.IntegrationIdentity.AsObject,
): IIntegrationIdentity | undefined {
	if (integration.identity === undefined) return undefined;

	return {
		...integration.identity,
		beamEnabled: integration.beamEnabled,
		inboundEnabled: integration.inboundEnabled,
		outboundEnabled: integration.outboundEnabled,
		addFutureWorkspaces: integration.addFutureWorkspaces,
		inboundLastUpdated: integration.inboundLastUpdated,
		outboundLastUpdated: integration.outboundLastUpdated,
		lastConnected: integration.lastConnected,
		lastDisconnected: integration.lastDisconnected,
		defaultWorkspaceId: integration.defaultWorkspaceId,
		integrationType: integration.integrationType,
	};
}
